import { Interval } from './interval'
import { Easing } from './easing'

export default function initializeTopText() {
    const TopText = document.querySelector("div.top-text")

    if (!TopText) {
        return
    }

    TopText.addEventListener("click", (event) => {
        const scrollY = window.scrollY || document.body.scrollTop || pageYOffset;
        const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
        
        if (scrollY <= vh) {
            scrollToY(vh)
        }
    })
}

const scrollToY = function () {
    let intrvl = new Interval({ duration: 800 }, function (pos) {
        const ease = Easing.calc(pos, Easing.InOut, Easing.Expo);
        const position = Math.mix(this.begin, this.end, ease);
        scrollTo(0, position);
    })
    intrvl.stop();

    return function scrollToY(y) {
        intrvl.stop()
        intrvl.begin = window.scrollY || pageYOffset || document.body.offsetTop
        intrvl.end = y
        intrvl.start()
    }
}()

Math.mix = Math.mix || function mix(from, to, at) {
    return from + ((to - from) * at)
}